module.exports = __webpack_public_path__ + "img/iPosCafe-Logo.ea7b5c77.png";